export const isDiscountsEnabled = (marketplaceId: number | undefined): boolean => {
    const enabledMarketplaceIds = (process.env.REACT_APP_DISCOUNTS_MARKETPLACE_IDS || '')
        .split(',')
        .map(id => id.replaceAll(/\D/g, ''))
        .filter(id => id !== '')
        .map(id => Number(id));
    return (
        marketplaceId !== undefined &&
        (enabledMarketplaceIds.length === 0 || enabledMarketplaceIds.includes(marketplaceId))
    );
};
